export default __webpack_public_path__ + "static/media/116t.4750f42f.jpg";